'use strict';

class DisclosureNav {
  constructor(domNode) {
    this.rootNode = domNode; // The root element of the navigation
    this.controlledNodes = []; // Stores references to the submenu elements
    this.openIndex = null; // Index of the currently open submenu
    this.useArrowKeys = true; // Flag to enable keyboard navigation

    this.initMenu(); // Initialize the menu
    this.rootNode.addEventListener('focusout', this.onBlur.bind(this)); // Handle focusout event
  }

  initMenu() {
    // Find top-level nodes (buttons/links) that control submenus within the rootNode
    this.topLevelNodes = [
      ...this.rootNode.querySelectorAll('button[aria-expanded][aria-controls], a[aria-expanded][aria-controls]')
    ];

    // Set up each top-level node
    this.topLevelNodes.forEach((node, index) => {
      const menuId = node.getAttribute('aria-controls');
      const menu = menuId ? this.rootNode.querySelector(`#${menuId}`) : null;

      if (menu) {
        this.controlledNodes[index] = menu;
        node.setAttribute('aria-expanded', 'false');
        this.toggleMenu(menu, false);
        menu.addEventListener('keydown', this.onMenuKeyDown.bind(this));
        node.addEventListener('click', this.onButtonClick.bind(this));
        node.addEventListener('keydown', this.onButtonKeyDown.bind(this));
      } else {
        this.controlledNodes[index] = null;
      }
    });
  }

  controlFocusByKey(keyboardEvent, nodeList, currentIndex) {
    switch (keyboardEvent.key) {
      case 'ArrowUp':
      case 'ArrowLeft':
        keyboardEvent.preventDefault();
        if (currentIndex > 0) {
          nodeList[currentIndex - 1].focus();
        }
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        keyboardEvent.preventDefault();
        if (currentIndex < nodeList.length - 1) {
          nodeList[currentIndex + 1].focus();
        }
        break;
      case 'Home':
        keyboardEvent.preventDefault();
        nodeList[0].focus();
        break;
      case 'End':
        keyboardEvent.preventDefault();
        nodeList[nodeList.length - 1].focus();
        break;
      default:
        break;
    }
  }

  toggleExpand(index, expanded) {
    if (this.openIndex !== null && this.openIndex !== index) {
      this.toggleExpand(this.openIndex, false);
    }

    if (this.topLevelNodes[index]) {
      this.openIndex = expanded ? index : null;
      this.topLevelNodes[index].setAttribute('aria-expanded', expanded);
      this.toggleMenu(this.controlledNodes[index], expanded);
    }
  }

  toggleMenu(domNode, show) {
    if (domNode) {
      domNode.style.display = show ? 'block' : 'none';
    }
  }

  onMenuKeyDown(event) {
    if (this.openIndex === null) return;

    const menuLinks = [...this.controlledNodes[this.openIndex].querySelectorAll('a')];
    const currentIndex = menuLinks.indexOf(document.activeElement);

    if (event.key === 'Escape') {
      this.topLevelNodes[this.openIndex].focus();
      this.toggleExpand(this.openIndex, false);
    } else if (this.useArrowKeys) {
      this.controlFocusByKey(event, menuLinks, currentIndex);
    }
  }

  onButtonClick(event) {
    const button = event.currentTarget;
    const buttonIndex = this.topLevelNodes.indexOf(button);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    this.toggleExpand(buttonIndex, !isExpanded);
  }

  onButtonKeyDown(event) {
    const key = event.key;
    const currentButton = event.currentTarget;
    const currentIndex = this.topLevelNodes.indexOf(currentButton);

    if (key === 'Escape') {
      this.toggleExpand(this.openIndex, false);
    } else if (this.useArrowKeys && key === 'ArrowDown') {
      event.preventDefault();
      if (this.openIndex === currentIndex) {
        const firstLink = this.controlledNodes[this.openIndex].querySelector('a');
        firstLink && firstLink.focus();
      }
    } else if (this.useArrowKeys) {
      this.controlFocusByKey(event, this.topLevelNodes, currentIndex);
    }
  }

  onBlur(event) {
    setTimeout(() => {
      if (!this.rootNode.contains(document.activeElement)) {
        this.toggleExpand(this.openIndex, false);
      }
    }, 0);
  }
}

window.addEventListener('load', function () {
  // Initialize desktop menu
  const desktopMenu = document.querySelector('#desktopMenu');
  if (desktopMenu) {
    new DisclosureNav(desktopMenu);
  }

  // Initialize mobile menu
  const mobileMenu = document.querySelector('#mobileMenu');
  if (mobileMenu) {
    new DisclosureNav(mobileMenu);
  }
});
